import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import { B2CProductDetailTileModel } from '@/types/B2CcontentServerContract';
import ProductDetail from '@/shared/product/details/ui/ProductDetail.vue';
import { toRef } from 'vue';
import useProductDetailTileModel from '@/shared/product/details/useProductDetailTileModel';
import ProductDetailPurchase from '@/b2c/product/purchase/ui/ProductDetailPurchase.vue';
import { provideAddToBasketEndpoints } from '@/shared/product/upsell/useProductDetailUpsellAddToBasket';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';
import { useAddToBasket } from '@/b2c/product/purchase/useAddToBasket';
import useBasket from '@/b2c/basket/useBasket';
import { provideBuyXAndGetYPercent } from '@/shared/checkout/basket/useBuyXAndGetYPercent';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2CProductDetailTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: B2CProductDetailTileModel
}



const { handleProductTileModelChange } = useProductDetailTileModel();
const { addToBasket } = useAddToBasket();
const { buyXAndGetYPctDiscount } = useBasket();

const content = toRef(props, 'content');
handleProductTileModelChange(content);
provideAddToBasketEndpoints(addToBasket);
provideBuyXAndGetYPercent(buyXAndGetYPctDiscount);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BlockMaxWidthHandler, null, {
      default: _withCtx(() => [
        _createVNode(ProductDetail, null, {
          default: _withCtx(() => [
            _createVNode(ProductDetailPurchase)
          ]),
          _: 1
        }),
        _createVNode(BlockList, {
          blocks: _unref(content).tiles
        }, null, 8, ["blocks"])
      ]),
      _: 1
    })
  ]))
}
}

})